import { Card, CardHeader, CardBody, Container, Row, Col } from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import { Spinner } from "reactstrap"; // Importar spinner

const AdjuntosOrdenEdicion = (props) => {
  let { id } = useParams();
  let { ordenId } = useParams();
  const cookie = new Cookies();
  const [documento, setDocumento] = useState([]);
  const [archivo, setArchivo] = useState(null);
  const [loading, setLoading] = useState(false); // Estado para el loading

  const subirArchivo = async () => {
    if (!archivo) {
      console.error("No se ha seleccionado ningún archivo.");
      return;
    }

    const formData = new FormData();
    formData.append("file", archivo);

    try {
      setLoading(true); // Activar el estado de carga
      const response = await axios.post(
        "https://inspecciongnvback.azurewebsites.net/api/v1/CreaAnexoOrden?OrdenId=" +
          props.ordenId +
          "&AnexoId=" +
          documento,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("Respuesta del servidor:", response.data);
      window.alert(response.data);
      window.location.reload("/");
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      window.alert(error);
    } finally {
      setLoading(false); // Desactivar el estado de carga
    }
  };

  const manejarCambioArchivo = (event) => {
    setArchivo(event.target.files[0]);
  };

  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerListaDocumentos/" +
        props.tipoOrden,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  const volver = (e) => {
    e.preventDefault(e);
    window.location.href = "/admin/Ordenes";
  };

  return (
    <>
      <Container className="mt--1" fluid>
        <Row>
          <Col>
            <Card className="shadow">
              <CardHeader className="border-0">
                <div className="text-center"></div>
                <hr />
              </CardHeader>
              <CardBody>
                <center>
                  <select
                    className="btn btn-secondary btn-user btn-block"
                    id="solicitudid"
                    onChange={(e) => setDocumento(e.target.value)}
                  >
                    <option value="">Seleccione el documento</option>
                    {list.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.adjunto}
                      </option>
                    ))}
                  </select>
                </center>
                <hr />
                <input
                  type="file"
                  name="files"
                  className="btn btn-secondary"
                  onChange={manejarCambioArchivo}
                  disabled={loading} // Deshabilitar input si está cargando
                />
                <br />
                <hr />
                {loading ? (
                  <Spinner color="primary" /> // Mostrar spinner mientras está cargando
                ) : (
                  <button
                    className="btn btn-primary btn-user btn-block"
                    onClick={subirArchivo}
                  >
                    Guardar
                  </button>
                )}
                <hr />
                <button
                  className="btn btn-info btn-user btn-block"
                  onClick={volver}
                  disabled={loading} // Deshabilitar botón si está cargando
                >
                  Finalizar
                </button>
                <hr />
                <hr />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <hr />
    </>
  );
};

export default AdjuntosOrdenEdicion;
